// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"205":"51993b1b","420":"e0935a0b","926":"9d33376f"}[chunkId] + ".css";
};